import React, { useEffect, FC, useState } from 'react';
import { InboxOutlined } from '@ant-design/icons';
import Avatar from '@mui/material/Avatar';
import { message, Upload } from 'antd';
import styled from 'styled-components';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import type { UploadChangeParam } from 'antd/es/upload';
import type { RcFile, UploadFile, UploadProps, UploadFileStatus } from 'antd/es/upload/interface';
import urlConfig from '../../../config';
import axios, { AxiosResponse, AxiosError } from 'axios'
import avatar_ico from '../assets/horse_avatar.jpg'
import { useHorsesStore } from '../../../stores/horses'
import { toJS } from 'mobx'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { List, ListItem as MuiListItem, ListItemText } from '@mui/material';
const { Dragger } = Upload;

const ListItem = styled(MuiListItem)({
    padding: '0 !important',
    height: '15px'
});
export const FileList: FC<{ queryId: string, customField?: { [name: string]: any } }> = ({ queryId, customField }) => {
    const stores = useHorsesStore()
    const [fileList, setFileList] = useState<Array<UploadFile<{ id: string }>>>([]);
    useEffect(() => {
        const query = queryId ? queryId : stores.profile?._ID;
        if (query) {
            const excuteQuery = queryId ? stores.getFilesByCalendId(query) : stores.getFiles(query)
            excuteQuery.then(files => {
                if (files) {
                    if (customField) {
                        files = files.filter(file => Number(file.event_type) == Number(customField!['event_type']))
                    } else {
                        files = files.filter(file => file.event_type == '' || file.event_type == 'Other')
                    }
                    const defaultLists = files.map(item => {
                        console.log(item._ID)
                        if (item._ID) {
                            return {
                                ...item,
                                uid: item._ID,
                                name: item.name,
                                status: 'done' as UploadFileStatus,
                                url: item.url,
                            }
                        } else {
                            return {
                                ...item,
                                uid: 'null',
                                name: item.name,
                                status: 'done' as UploadFileStatus,
                                url: item.url,
                            }
                        }

                    })
                    setFileList(defaultLists)

                }
            })
        }


    }, [stores.profile?._ID, queryId])

    return (
        <List>
            {fileList.map((file) => (
                <ListItem key={file.uid}>
                    <ListItemText
                        primary={<a href={file.url} download={file.name}>{file.name}</a>}
                    />
                </ListItem>
            ))}
        </List>
    );
};


const App: React.FC<{ hideFileList?: boolean, queryId?: string, customField?: Object; completeHandle?: (response: { fileUrl: string; name: string }) => void, visitId?: string }> = (input) => {
    const stores = useHorsesStore()
    const [fileList, setFileList] = useState<Array<UploadFile<{ id: string }>>>([])


    const handleChange: UploadProps['onChange'] = (info) => {
        let newFileList = [...info.fileList];



        //  Read from response and show file link



        const { status } = info.file;

        if (status !== 'uploading') {
            console.log(info.file, info.fileList);
        }

        if (status === 'done') {
            const data = JSON.parse(info.file.xhr.response).data

            if (data) {
                if (input.completeHandle) {
                    input.completeHandle({ fileUrl: data.url, name: info.file.name })
                } else if (stores.profile?._ID) {
                    stores.addFile({
                        name: info.file.name,
                        url: data.url,
                        profile_id: stores.profile._ID,
                        ...input.customField
                    })
                } else {
                    message.error(`${info.file.name} file upload failed, You need create the profile first.`);
                    return
                }

                newFileList = newFileList.map((file) => {
                    if (file.response) {
                        // Component will show file.url as link
                        file.url = file.response.data.url;
                    }
                    return file;
                });

                setFileList(newFileList)
                message.success(`${info.file.name} file uploaded successfully.`);
            }
        } else if (status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }

        setFileList(newFileList);
    };
    const props = {
        action: urlConfig.url + '/' + urlConfig.baseUrl + 'reset/v1/media_upload',
        onChange: handleChange,
        multiple: true,
        name: 'async-upload',

    }


    useEffect(() => {
        if (input.hideFileList == true) {
            return
        }
        const query = input.queryId ? input.queryId : stores.profile?._ID;
        if (query) {
            const excuteQuery = input.visitId ? stores.getFilesByVisitId(input.visitId) : input.queryId ? stores.getFilesByCalendId(query) : stores.getFiles(query)
            excuteQuery.then(files => {
                if (files) {
                    if (input.customField) {
                        files = files.filter(file => Number(file.event_type) == Number(input.customField!['event_type']))
                    } else {
                        files = files.filter(file => file.event_type == '' || file.event_type == 'Other')
                    }
                    const defaultLists = files.map(item => {
                        console.log(item._ID)
                        if (item._ID) {
                            return {
                                ...item,
                                uid: item._ID,
                                name: item.name,
                                status: 'done' as UploadFileStatus,
                                url: item.url,
                            }
                        } else {
                            return {
                                ...item,
                                uid: 'null',
                                name: item.name,
                                status: 'done' as UploadFileStatus,
                                url: item.url,
                            }
                        }

                    })
                    setFileList(defaultLists)
                }
            })
        }


    }, [stores.profile?._ID, input.queryId, input.visitId])

    return <Wrapper>
        <HelpText>Drag and drop files here (50mb MAX):</HelpText>
        <Dragger {...props} fileList={fileList}
            onRemove={(file) => {
                return stores.delFiles(file.uid, stores.profile?._ID ? stores.profile?._ID : '').then(_ => true).catch(_ => false)
            }}
            disabled={input.queryId != undefined ? true : !stores.isEditingMode}
        >
            Select Files
        </Dragger>
    </Wrapper>
};


const getBase64 = (img: RcFile, callback: (url: string) => void) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result as string));
    reader.readAsDataURL(img);
};

const beforeUpload = (file: RcFile) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
        message.error('Image must smaller than 5MB!');
    }
    return isJpgOrPng && isLt5M;
};


export const AvatarUpload: React.FC<{ img?: string, onFinished: (fileUrl: string) => void }> = (props) => {
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState<string | undefined>(avatar_ico);
    const stores = useHorsesStore()
    const [showAlert, setShowAlert] = useState(false)

    const before = async (file: RcFile) => {
        if (stores.profile?._ID) {
            beforeUpload(file)
        } else {
            setShowAlert(true)
        }

    }
    const uploadImage = async options => {
        const { onSuccess, onError, file, onProgress } = options;

        const fmData = new FormData();
        const config = {
            headers: { "content-type": "multipart/form-data" },
        };
        fmData.append("async-upload", file);
        try {

            const res = await axios.post(
                urlConfig.url + '/' + urlConfig.baseUrl + 'reset/v1/media_upload',
                fmData,
                config
            );

            props.onFinished(res.data.data.url)
            onSuccess("Ok");
            console.log("server res: ", res);
        } catch (err) {
            console.log("Eroor: ", err);
            const error = new Error("Some error");
            onError({ err });
        }
    };

    const handleChange: UploadProps['onChange'] = (info: UploadChangeParam<UploadFile>) => {
        console.log(info)
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            getBase64(info.file.originFileObj as RcFile, (url) => {
                setLoading(false);
                setImageUrl(url);
            });
        }
    };

    useEffect(() => {
        setImageUrl(props.img)
    }, [props.img])

    return <>
        <Upload
            name="async-upload"
            customRequest={uploadImage}
            showUploadList={false}
            beforeUpload={before}
            onChange={handleChange}
            disabled={!stores.isEditingMode}
        >
            <StyledAvatar alt="Place Holder" src={imageUrl} sx={{ width: 200, height: 200 }} />
        </Upload>
    </>

}


const StyledAvatar = styled(Avatar)`
    margin:10px;
`
const Wrapper = styled.div`
   .ant-upload {
       height: 30px;
        width: 110px;
        .ant-upload-btn {
            padding:0;
        }
    }
`
const HelpText = styled.p`
    color: rgba(0, 0, 0, 0.6);
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    text-align: left;
    margin-top: 3px;
    margin-right: 14px;
    margin-bottom: 0;
    margin-left: 14px;
`



function MsgModal(show, onClose) {

    return (
        <div>
            <Dialog
                open={show}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Use Google's location service?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Please create the profile first.
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default App;